// 強化の「何がどれだけ強くなるか」：強化の前と後の文を比べ、変わる数字だけを光らせる（式神・建物図面・装備で共通）
import { esc } from './dom';

const NUM = /(\d[\d,]*(?:\.\d+)?%?)/;

/** after の文の中で、before と違う数字を「前→後」にして後を光らせる（数字の並びが違えば after をそのまま） */
export function numDiffHtml(before: string, after: string): string {
  const a = after.split(NUM);
  const b = before.split(NUM);
  if (a.length !== b.length) return esc(after);
  return a.map((t, i) => (i % 2 === 1 && t !== b[i] ? `<span class="lv-was">${esc(b[i])}</span><i class="lv-arrow">→</i><em class="lv-up">${esc(t)}</em>` : esc(t))).join('');
}

export interface LvRow {
  label: string;
  before: string;
  after: string;
}
/** 変わる行だけを並べた表。見出し（例「式神Lv3→4で」）つき。変わる行が無ければ空 */
export function lvBoxHtml(title: string, rows: LvRow[], note = ''): string {
  const ch = rows.filter((r) => r.before !== r.after);
  if (!ch.length && !note) return '';
  return `<div class="lv-box">${title ? `<h4>${esc(title)}</h4>` : ''}<ul>${ch.map((r) => `<li><b>${esc(r.label)}</b><span>${numDiffHtml(r.before, r.after)}</span></li>`).join('')}</ul>${note ? `<p class="lv-note">${note}</p>` : ''}</div>`;
}
